"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineFuels = exports.getTransactionPOI = exports.scaleEmissions = exports.getFuelColor = void 0;
const lodash_1 = require("lodash");
const theme_1 = require("../../theme");
const getFuelColor = (fuel) => {
    switch (fuel) {
        case 1:
            return theme_1.theme.colors.grey(1);
        case 2:
            return theme_1.theme.colors.grey(2);
        case 8:
            return theme_1.theme.colors.grey(3);
        case 23:
            return theme_1.theme.colors.greenScale[0];
        case 24:
            return theme_1.theme.colors.greenScale[1];
        default:
            return theme_1.theme.colors.blue;
    }
};
exports.getFuelColor = getFuelColor;
const scaleEmissions = (amountT) => {
    if (Math.abs(amountT) > 100) {
        return (0, lodash_1.round)(amountT, 0);
    }
    if (Math.abs(amountT) > 10) {
        return (0, lodash_1.round)(amountT, 1);
    }
    return (0, lodash_1.round)(amountT, 2);
};
exports.scaleEmissions = scaleEmissions;
const getTransactionColor = (type) => {
    switch (type) {
        case "from":
            return theme_1.theme.colors.darkBlue;
        case "to":
            return theme_1.theme.colors.green;
        case "neutral":
            return theme_1.theme.colors.blackText;
    }
};
const getTransactionPOI = (transaction, type) => {
    return {
        date: new Date(transaction.transaction_date),
        text: `${transaction.quantity} tCO₂e from ${transaction.from.name} to ${transaction.to.name}`,
        color: getTransactionColor(type),
    };
};
exports.getTransactionPOI = getTransactionPOI;
const combineFuels = (fuelAmounts) => {
    return fuelAmounts.reduce((result, f) => {
        return {
            ...result,
            [f.fuel]: f.amount + (result[f.fuel] ?? 0),
        };
    }, {});
};
exports.combineFuels = combineFuels;
